// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__m0egA","right":"styles_right__kBgay"};